import React from 'react';
import { ClockIcon, EnvelopeIcon, ArrowRightOnRectangleIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../context/AuthContext';

const PendingApproval = () => {
  const { user, logout } = useAuth();

  return (
    <div className="min-h-screen bg-gradient-to-br from-yellow-50 via-white to-orange-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Icon */}
        <div className="text-center mb-8">
          <div className="inline-block p-4 bg-yellow-100 rounded-full mb-4">
            <ClockIcon className="h-16 w-16 text-yellow-600 animate-pulse" />
          </div>
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Hesabınız İnceleniyor
          </h1>
          <p className="text-gray-600">
            Kaydınız başarıyla alındı
          </p>
        </div>

        {/* Card */}
        <div className="bg-white rounded-xl shadow-lg p-8 border border-gray-200">
          {/* User Info */}
          <div className="mb-6">
            <p className="text-sm text-gray-600 mb-1">Hoş geldin,</p>
            <p className="text-xl font-bold text-gray-900">{user?.name}</p>
            <p className="text-sm text-gray-500 flex items-center mt-1">
              <EnvelopeIcon className="h-4 w-4 mr-1" />
              {user?.email}
            </p>
          </div>

          {/* Status */}
          <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <ClockIcon className="h-5 w-5 text-yellow-600 mr-3 mt-0.5 flex-shrink-0" />
              <div>
                <h3 className="font-semibold text-yellow-900 mb-1">
                  Onay Bekleniyor
                </h3>
                <p className="text-sm text-yellow-800">
                  Hesabınız yönetici onayı için beklemede. Onaylandıktan sonra tüm özelliklere erişebileceksiniz.
                </p>
              </div>
            </div>
          </div>

          {/* Info */}
          <div className="space-y-3 mb-6">
            <div className="flex items-start text-sm">
              <span className="inline-block w-2 h-2 bg-gray-400 rounded-full mr-3 mt-1.5 flex-shrink-0"></span>
              <p className="text-gray-600">
                Onay süreci genellikle <strong className="text-gray-900">24 saat içinde</strong> tamamlanır
              </p>
            </div>
            <div className="flex items-start text-sm">
              <span className="inline-block w-2 h-2 bg-gray-400 rounded-full mr-3 mt-1.5 flex-shrink-0"></span>
              <p className="text-gray-600">
                Hesabınız onaylandığında <strong className="text-gray-900">e-posta ile</strong> bilgilendirileceksiniz
              </p>
            </div>
            <div className="flex items-start text-sm">
              <span className="inline-block w-2 h-2 bg-gray-400 rounded-full mr-3 mt-1.5 flex-shrink-0"></span>
              <p className="text-gray-600">
                Herhangi bir sorun olması durumunda <strong className="text-gray-900">destek ekibimizle</strong> iletişime geçebilirsiniz
              </p>
            </div>
          </div>

          {/* Logout Button */}
          <button
            onClick={logout}
            className="w-full flex items-center justify-center px-4 py-3 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 transition font-medium"
          >
            <ArrowRightOnRectangleIcon className="h-5 w-5 mr-2" />
            Çıkış Yap
          </button>
        </div>

        {/* Footer */}
        <div className="text-center mt-6">
          <p className="text-sm text-gray-500">
            Sorularınız için:{' '}
            <a href="mailto:destek@denemekoc.com" className="text-primary-600 hover:text-primary-700 font-medium">
              destek@denemekoc.com
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default PendingApproval;
